import SIcon from './src/main';

export default SIcon;
